module.exports = __webpack_public_path__ + "img/旋转.a9bb8360.svg";